export default __webpack_public_path__ + "static/media/6_cortada.965336de.webp";